import { useState, useEffect } from "react";
import { Company } from "../../../utils/models/Company";
import Form from 'react-bootstrap/Form';
import './CompanyForm.scss'
import { useTranslation } from "react-i18next";
import { AWSelect } from "aw-select";
import { useTheme } from "../../../utils/contexts/ThemeContext";

const CompanyForm = (props: {
    formLock: boolean, edit: boolean; companyAux: Company, sendChange: (event: any) => void, options: any, selected: any, onChangeSelect: (e: any) => void,
    onSelectedFile: (img: string) => void
}) => {
    const { companyAux } = props
    const { t } = useTranslation();

    const [selectedImage, setSelectedImage] = useState('')

    const handleImageChange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader()
            reader.readAsDataURL(e.target.files[0])

            reader.onload = () => {
                const imgSrc = reader.result as string
                setSelectedImage(imgSrc)
                if (reader.result) {
                    props.onSelectedFile(imgSrc)
                }
            }
        }
    };

    useEffect(() => {
        if (companyAux.image && companyAux.image.length > 0) {
            setSelectedImage(companyAux.image)
        }
    }, [companyAux])


    const onInputChange = (event: any) => {
        props.sendChange(event)
    };

    const onDelImage = () => {
        setSelectedImage('')
        props.onSelectedFile('')
    };

    
    const theme = useTheme();

    const dark = theme.theme==='dark';


    return (
        <div className="p-3 rounded-1" id='formCompanyContainer'>
            <Form>
                <div className="row mb-3 mt-2">
                    <div className="col">
                        <Form.Check disabled={props.formLock} name="active" type="checkbox" label={t('Active')} defaultChecked={companyAux.active} onClick={onInputChange} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{`${t('Name')}*`}</Form.Label>
                        <Form.Control required disabled={props.formLock} name="name" className="inputStyle" type="text" onChange={onInputChange} value={companyAux.name} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Address')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="address" type="text" className="inputStyle" onChange={onInputChange} value={companyAux.address} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Country')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="country" type="text" className="inputStyle" onChange={onInputChange} value={companyAux.country} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Email')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="email" type="email" className="inputStyle" onChange={onInputChange} value={companyAux.email} />
                    </div>
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('City')}</Form.Label>
                        <Form.Control disabled={props.formLock} name="city" type="text" className="inputStyle" onChange={onInputChange} value={companyAux.city} />
                    </div>
                    <div className="col d-none d-lg-block">
                        <Form.Label className='mb-0'>{`Logo (<70kb, ${t('LandscapeImage')})`}</Form.Label>
                        <Form.Control disabled={props.formLock} name="logo" accept="image/*" type="file" className="inputStyle" onChange={handleImageChange} />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 col-lg">
                        <Form.Label className='mb-0'>{t('Installations')}</Form.Label>
                        <AWSelect dark={dark} placeholder='Container' className="inputStyle selectStyle" closeMenuOnSelect={false} defaultValue={props.selected} onChange={props.onChangeSelect} options={props.options} />

                    </div>
                    <div className="col">
                    </div>
                    <div className="col text-center">
                        <div className='row'>
                            <div className='col'>
                                {selectedImage.length > 0 && (
                                    <img className="mt-3" height={100} src={selectedImage} alt="Company Logo" />
                                )}
                            </div>
                            <div className='col-2 text-end'>
                                {selectedImage.length > 0 && <button type='button' onClick={onDelImage} disabled={props.formLock} className="btn-Custom btn-IDRed ms-2"><i className="bi bi-x-circle"></i></button>}
                            </div>
                        </div>
                    </div>
                    <div className="col d-block d-lg-none">
                        <Form.Label className='mb-0'>{`Logo (<70kb, ${t('LandscapeImage')})`}</Form.Label>
                        <Form.Control disabled={props.formLock} name="logo" className="inputStyle" accept="image/*" type="file" onChange={handleImageChange} />
                    </div>
                </div>
            </Form>
        </div>
    )
}
export default CompanyForm;